/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/digital_advise_medium'
export default icon
